import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UIInitialState {
  activePage: string;
}

const initialState: UIInitialState = {
    activePage: "Assets",
}

export const UISlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        changePage: (state, action: PayloadAction<string>) => {
                state.activePage = action.payload;
        }, 
    }
})

export const { changePage } = UISlice.actions;
export default UISlice.reducer;